import { Helmet } from 'react-helmet';
import {
    Box, Button,
    Container,
    Grid, Typography,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import newsService from "../../../services/news.service";
import { urlify } from "../../../services/global.service";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import iconArrow from "../../../assets/images/news/icon-arrow.svg";
import defaultBanner from "../../../assets/images/announcement/default.jpg"

import * as Util from "../../../services/global.service";

const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    }
};



const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"

    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9  !important",
        color: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
        "& > .MuiButton-root": {
            color: "none",
        }

    },

    processBgRubric: {
        background: "#85AEB0 !important",
    },

    processBgCompetency: {
        background: "#958CCB !important",
    },

})



const ContentNew = () => {

    const { t } = useTranslation()

    let { serial } = useParams();
    useEffect(() => {
        getContentNews();
    }, []);

    const [dataContentNews, setContentNews] = React.useState([]);


    const getContentNews = () => {
        newsService.content(serial).then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {
                    setContentNews(response.data)
                }


            },
        );
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    return (
        <>
            <Helmet>
                <title>Announcement | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3,
                    width: '100%'
                }}
            >
                <Container maxWidth="xl">

                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("news.label.homePage")}</span> / <span style={styles.link} onClick={() => clickLink('/kpi/announcement/allnews')}>{t("news.label.news")}</span> / <span style={styles.end} >{t("news.label.content")}</span> </Typography>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs sm md lg>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }} >
                                <Box sx={{ width: "100%" }}>
                                    <Typography fontSize={36} color="#404349" lineHeight="39.6px" paddingBottom="14px" fontWeight="600px">
                                        {t("news.label.news")}
                                    </Typography>
                                    <Box sx={{
                                        display: "flex", flexDirection: "row", alignItems: "Center", cursor: 'pointer', "&:hover": {
                                            textDecoration: "underline"
                                        },
                                    }} onClick={() => navigate(-1)}>
                                        <img src={iconArrow} style={{ maxWidth: '22px', maxHeight: '13px' }}>

                                        </img>
                                        <Typography fontSize={18} lineHeight="19.8px" color="#404349" fontWeight="400px" sx={{ paddingLeft: '8px' }}>
                                            {t("news.label.back")}
                                        </Typography>

                                    </Box>
                                </Box>
                            </Box>

                            <Box sx={{ display: "flex", width: '100%' }}>

                                <Box sx={{ "box-shadow": '0px 0px 0px rgba(0, 0, 0, 0.1)', "border-radius": '0px', margin: '20px', width: '100%' }}>
                                    <Box sx={{ padding: '20px' }}>
                                        <Box sx={{ borderRadius: '5px', width: '100%' }}>
                                            <img src={dataContentNews?.thumbnail ? dataContentNews?.thumbnail : defaultBanner} style={{ width: '100%' }} alt="banner" />
                                        </Box>
                                        <Typography fontSize={36} lineHeight="39.5px" color="#404349" fontWeight={600} sx={{ paddingTop: "30px" }} >
                                            {formatData(dataContentNews?.title, "-")}
                                        </Typography>

                                        <Box sx={{ display: "flex", flexFlow: "row wrap", width: '100%', paddingTop: "20px", alignItems: "center", paddingTop: '10px' }}>
                                            <Typography fontSize={14} lineHeight="17px" fontWeight={600} color="#949494" >
                                                {formatData(dataContentNews?.client, "-")}
                                            </Typography>

                                            <Typography fontSize={14} lineHeight="17px" fontWeight={400} color="#949494" sx={{ paddingLeft: "10px" }}>
                                                {Util.dateDayFormat(dataContentNews?.start_at, "-")}
                                            </Typography>

                                            {
                                                dataContentNews.tags !== undefined && dataContentNews?.tags.length > 0 ?
                                                    dataContentNews?.tags.map(itemname => (
                                                        <Button sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, padding: "5px 20px", marginLeft: "15px", 'pointer-events': 'none' }}
                                                            className={classes.processBgGoals}>
                                                            <Typography fontSize={14} lineHeight="16px" fontWeight={500} color="#FFFFFF" >
                                                                {itemname}
                                                            </Typography>
                                                        </Button>
                                                    )
                                                    )
                                                    : null
                                            }

                                        </Box>

                                        <Typography fontSize={18} lineHeight="29.5px" color="#404349" fontWeight={300} sx={{ "text-indent": "30px", paddingTop: "30px" }} dangerouslySetInnerHTML={{ __html: urlify(dataContentNews?.description) }}>
                                            {/* {formatData(dataContentNews?.description, "-")} */}
                                        </Typography>

                                    </Box>

                                </Box>


                            </Box>


                        </Grid>


                    </Grid>

                </Container>
            </Box>
        </>
    )
};
export default ContentNew;


